import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import styled, { css } from 'styled-components';
import { FormGroup, ControlGroup, InputGroup, TextArea } from '@blueprintjs/core';
import { Button, ButtonGroup, Dialog, Icon, FileInput, MenuItem } from '@blueprintjs/core';
import { HTMLSelect } from '@blueprintjs/core';
import { Popover2, Tooltip2 } from '@blueprintjs/popover2';
import { Suggest2 } from '@blueprintjs/select';
import { Alignment, Classes, IconSize, DrawerSize, Position, Colors, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Pannellum } from '$components/pannellum-react-local';
import { useAuth } from '$root/contexts/auth';

const LINK_CNT = 5;

export default function EditTagLinkDialog(props)
{
    const {
        isOpen, projectId, documentId, tagId,
        mode, yaw, pitch, orientation, onClose
    } = props
    const { getProtectedResource, postFormDataProtected, postProtectedResource } = useAuth();

    const [ isWorking, setIsWorking ] = useState(false);
    const [ tagSettings, setTagSettings ] = useState({
        categories: [],
        disciplines: [],
        statuses: [],
        contextsOriginal: [],
        contexts: [],
    });
    const [ tagData, setTagData ] = useState({
        title:'',
        tagId:'',
        category:-1,
        discipline:-1,
        status:-1,
        comment:'',
        photo:null,
    });

    const [ tagLinksData, setTagLinksData ] = useState({
        links: [...new Array(LINK_CNT)].map(() => ({ id:-1, context:"", link:""})),
    });


    const onEditTagLinks = useCallback(() => {

        setIsWorking(true);

        console.log('tagLinksData',tagLinksData)

        let postData =
        {
            "tag_id": tagId,
            "link":[]
        };

        for (const item of tagLinksData.links) {
            if (item.context.trim().length === 0) continue;
            if (item.link.trim().length === 0) continue;

            postData.link.push({id:item.id,context: item.context.trim(),link: item.link.trim()});
        }
        console.log('postData', postData)
        // const data = new FormData();
        //
        // data.append("documentId", documentId);
        // data.append("id", tagId);
        // data.append("comment", tagData.comment);
        // data.append("status", tagData.status);
        // data.append("title", tagData.title);
        // data.append("category", tagData.category);
        // data.append("discipline", tagData.discipline);
        //
        // if (tagData.photo)
        //     data.append("photo", tagData.photo);

        postProtectedResource(`/tag2.php?task=tag-link-edit`, postData)
            .then(res => {
                onClose(true);
            })
            .catch(err => {
                console.error(JSON.stringify(err));

                onClose(false);
            })
        ;

    }, [tagId, tagLinksData, setIsWorking]);


    useEffect(() => {
        Promise
            .all([
                getProtectedResource(`/tag2.php?task=tag-link-context&pid=${projectId}`),
                getProtectedResource(`/tag2.php?task=tag-link&tid=${tagId}`),
            ])
            .then(([respContext, respTagLinks]) => {
                if (_.isArray(respContext.data.contexts)) {

                    let contexts = respContext.data.contexts;
                    let contextsC = contexts.map(s => s.toLowerCase());
                    if (contextsC.indexOf("adatlap") < 0) contexts.push("adatlap");
                    if (contextsC.indexOf("kezelési kézikönyv") < 0) contexts.push("kezelési kézikönyv")
                    if (contextsC.indexOf("beépítési jegyzőkönyv") < 0) contexts.push("beépítési jegyzőkönyv")
                    if (contextsC.indexOf("karbantartási utasítás") < 0) contexts.push("karbantartási utasítás")
                    if (contextsC.indexOf("rajz") < 0) contexts.push("rajz")

                    setTagSettings(old => ({
                        ...old,
                        contexts: [...contexts],
                        contextsOriginal: [...contexts]
                    }))
                }
                if (_.isArray(respTagLinks.data.tagLinks)) {
                    const links = respTagLinks.data.tagLinks.map(tl => ({
                        id: tl.id,
                        context: tl.link_context,
                        link: tl.link
                    }));
                    while (links.length < LINK_CNT)
                    {
                        links.push({ id:-1, context:"", link:""});
                    }
                    setTagLinksData(old => ({
                        ...old,
                        links: links
                    }));
                }
            })
            .catch(err => {
                console.error(err)
            })
    }, [projectId, tagId]);


    useEffect(() => {
        Promise
            .all([
                getProtectedResource(`/tag2.php?task=tag-settings&pid=${projectId}`),
                getProtectedResource(`/tag2.php?task=tag-state&tid=${tagId}`)
            ])
            .then(([respSettings, respTag]) => {

                const { categories, disciplines, statuses } = respSettings.data.settings;
                const { tag } = respTag.data;

                setTagSettings(old => ({
                    ...old,
                    categories:categories,
                    disciplines:disciplines,
                    statuses:statuses,
                }));
                setTagData(old => ({
                    ...old,
                    title:tag.title,
                    tag:tag.tag,
                    category:tag.category_id,
                    discipline:tag.discipline_id,
                    status:tag.status_id,
                }));
            })
            .catch(() => {
            })
        ;
    }, [mode]);


    const caption = `Csatolmányok: ${tagData.tag}`;

    const contextItemRenderer = useCallback((item, status) => {
        return <MenuItem
            key={item}
            text={item}
            active={status.modifiers.active}
            onClick={status.handleClick}
        />;
    });

    const contextNewItemRenderer = useCallback((item, active, handleClick) => {
        return <MenuItem
            key={item}
            text={item}
            active={active}
            onClick={handleClick}
        />;
    });

    const contextOnItemSelect = useCallback((index, item) => {
        setTagSettings(s => ({...s, contexts: [...new Set([...s.contextsOriginal, item])]}))
        setTagLinksData(s => {
            let result = {...s};
            result.links[index].context = item;
            return result;
        })
    }, [tagSettings, tagLinksData]);


    const tagLinkChanged = useCallback((index, link) => {
        setTagLinksData(s => {
            let result = {...s};
            result.links[index].link = link;
            return result;
        })
    }, [tagLinksData]);


    const tagLinkDelete = useCallback((index) => {
        setTagLinksData(s => {
            let result = {...s};
            result.links[index].id = -1;
            result.links[index].context = "";
            result.links[index].link = "";
            return result;
        })
    }, [tagLinksData]);


    let tagLinks = [...new Array(LINK_CNT)].map((v,linkIndex) => {
        let button = <Button icon={IconNames.Undo} onClick={() => tagLinkDelete(linkIndex)}></Button>;

        return (<>
            <Suggest2
                id={'tag-link-context'}
                fill
                popoverProps={{ minimal:true }}
                items={tagSettings.contexts}
                itemRenderer={contextItemRenderer}
                inputValueRenderer={item => item}
                createNewItemFromQuery={qry => qry}
                createNewItemRenderer={contextNewItemRenderer}
                selectedItem={tagLinksData.links[linkIndex].context}
                onItemSelect={item => contextOnItemSelect(linkIndex, item)}
                inputProps={{placeholder:""}}
            />
            <InputGroup
                id={'tag-link'}
                value={tagLinksData.links[linkIndex].link}
                onChange={(e) => tagLinkChanged(linkIndex, e.target.value)}
            />
            <div>{button}</div>
        </>)
    });


    return (
        <Dialog
            title={caption}
            canEscapeKeyClose
            canOutsideClickClose
            isOpen={isOpen}
            onClose={onClose}
            style={{
                minWidth: '30rem',
                minHeight: '10rem',
                zIndex: 150
            }}
        >
            <div style={{width: '100%', height: '100%', padding:'1rem 1rem 0 1rem'}}>
                <ControlGroup fill>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 2fr auto",
                        gap: "4px 4px",
                    }}>
                        <div style={{ alignSelf:'center', justifySelf:'start' }}>Típus</div>
                        <div style={{ alignSelf:'center', justifySelf:'start' }}>Csatolmány</div>
                        <div style={{ }}><div></div></div>
                        {tagLinks}
                    </div>
                </ControlGroup>
                <div style={{height:8}}></div>
                <ControlGroup fill>
                    <div className={Classes.FILL} />
                    <Button text={'OK'}
                            style={{minWidth:'6rem'}}
                            className={Classes.FIXED}
                            loading={isWorking}
                            disabled={tagData.title.trim().length === 0 || isWorking}
                            onClick={onEditTagLinks}
                    />
                    <Button text={'Mégsem'}
                            style={{minWidth:'6rem'}}
                            disabled={isWorking}
                            className={Classes.FIXED}
                            onClick={() => onClose(false)}
                    />
                </ControlGroup>
                <div style={{height:8}}></div>
            </div>
        </Dialog>
    );
}